import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import nav from './locales/ru/nav.json';
import hero from './locales/ru/hero.json';
import about from './locales/ru/about.json';
import offer from './locales/ru/offer.json';
import cta from './locales/ru/cta.json';
import footer from './locales/ru/footer.json';
import seo from './locales/ru/seo.json';
import brand from './locales/ru/brand.json';
import legal from './locales/ru/legal.json';
import pages from './locales/ru/pages.json';

import navUA from './locales/ua/nav.json';
import heroUA from './locales/ua/hero.json';
import aboutUA from './locales/ua/about.json';
import offerUA from './locales/ua/offer.json';
import ctaUA from './locales/ua/cta.json';
import footerUA from './locales/ua/footer.json';
import seoUA from './locales/ua/seo.json';
import brandUA from './locales/ua/brand.json';
import legalUA from './locales/ua/legal.json';
import pagesUA from './locales/ua/pages.json';

import navEN from './locales/en/nav.json';
import heroEN from './locales/en/hero.json';
import aboutEN from './locales/en/about.json';
import offerEN from './locales/en/offer.json';
import ctaEN from './locales/en/cta.json';
import footerEN from './locales/en/footer.json';
import seoEN from './locales/en/seo.json';
import brandEN from './locales/en/brand.json';
import legalEN from './locales/en/legal.json';
import pagesEN from './locales/en/pages.json';

// Получаем настройки локализации из переменных окружения
const availableLocales = (process.env.REACT_APP_AVAILABLE_LOCALES || 'ua,ru').split(',').map(locale => locale.trim());
const defaultLocale = process.env.REACT_APP_DEFAULT_LOCALE || 'ua';
const fallbackLocale = process.env.REACT_APP_FALLBACK_LOCALE || 'ua';

// Все доступные ресурсы локализации
const allResources = {
  ru: {
    nav: nav,
    hero: hero,
    about: about,
    offer: offer,
    cta: cta,
    footer: footer,
    seo: seo,
    brand: brand,
    legal: legal,
    pages: pages,
  },
  ua: {
    nav: navUA,
    hero: heroUA,
    about: aboutUA,
    offer: offerUA,
    cta: ctaUA,
    footer: footerUA,
    seo: seoUA,
    brand: brandUA,
    legal: legalUA,
    pages: pagesUA,
  },
  en: {
    nav: navEN,
    hero: heroEN,
    about: aboutEN,
    offer: offerEN,
    cta: ctaEN,
    footer: footerEN,
    seo: seoEN,
    brand: brandEN,
    legal: legalEN,
    pages: pagesEN,
  },
};

// Создаем ресурсы только для доступных локалей
const resources = {};
availableLocales.forEach(locale => {
  if (allResources[locale]) {
    resources[locale] = allResources[locale];
  }
});

i18n.use(initReactI18next).init({
  lng: defaultLocale,
  fallbackLng: fallbackLocale,
  ns: ['nav', 'hero', 'about', 'offer', 'cta', 'footer', 'seo', 'brand', 'legal', 'pages'],
  defaultNS: 'nav',
  resources: resources,
  interpolation: {
    escapeValue: false,
  },
});

// Экспортируем конфигурацию локализации для использования в других компонентах
export const localeConfig = {
  availableLocales,
  defaultLocale,
  fallbackLocale,
  showLanguageSwitcher: process.env.REACT_APP_SHOW_LANGUAGE_SWITCHER !== 'false',
  localeLabels: (process.env.REACT_APP_LOCALE_LABELS || 'ua:UA,ru:RU')
    .split(',')
    .reduce((acc, pair) => {
      const [locale, label] = pair.split(':');
      if (locale && label) {
        acc[locale.trim()] = label.trim();
      }
      return acc;
    }, {}),
};

export default i18n;